/* NOBL V2 behaviors — rail, reveal, PDP gallery. Threshold uses real links (no JS needed to navigate). */
(function(){
  'use strict';
  document.documentElement.classList.remove('no-js');

  function rail(){
    var fill=document.querySelector('.nbl-rail .fill'),live=document.querySelector('.nbl-rail .live'),track=document.querySelector('.nbl-rail .track');
    if(!fill) return;
    function s(){var h=document.documentElement,max=h.scrollHeight-h.clientHeight,p=max>0?h.scrollTop/max:0;
      if(track)fill.style.height=(track.getBoundingClientRect().height*p)+'px';
      if(live){var top=p>=.99;live.textContent=top?'SMT':String(Math.round(p*999)).padStart(3,'0');live.classList.toggle('top',top);}}
    window.addEventListener('scroll',s,{passive:true});window.addEventListener('resize',s);s();
  }
  function reveal(){
    var els=document.querySelectorAll('.nbl-rev');
    if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('in');});return;}
    var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('in');io.unobserve(x.target);}});},{threshold:.12});
    els.forEach(function(e){io.observe(e);});
  }
  function gallery(){
    document.querySelectorAll('[data-nbl-gallery]').forEach(function(root){
      var imgs=root.querySelectorAll('.nbl-stage img'),thumbs=root.querySelectorAll('.nbl-thumb');
      function on(i){imgs.forEach(function(m,k){m.classList.toggle('on',k===i);});thumbs.forEach(function(t,k){t.classList.toggle('on',k===i);});}
      thumbs.forEach(function(t,i){t.addEventListener('click',function(){on(i);});});on(0);
      var groups=root.querySelectorAll('[data-nbl-opt]'),select=root.querySelector('[data-nbl-variant]'),price=root.querySelector('[data-nbl-price]'),add=root.querySelector('[data-nbl-add]');
      if(!select)return;
      function sel(){var v=[];groups.forEach(function(g){var a=g.querySelector('.nbl-pill.on');if(a)v.push(a.dataset.value);});return v.join(' / ');}
      function sync(){var s=sel();var m=Array.prototype.find.call(select.options,function(o){return o.dataset.options===s;});
        if(m){select.value=m.value;if(price)price.textContent=m.dataset.price;
          if(add){if(m.disabled){add.textContent='Sold out';add.disabled=true;}else{add.textContent=add.dataset.label||'Add to cart';add.disabled=false;}}}}
      groups.forEach(function(g){g.addEventListener('click',function(e){var b=e.target.closest('.nbl-pill');if(!b)return;
        g.querySelectorAll('.nbl-pill').forEach(function(p){p.classList.remove('on');});b.classList.add('on');sync();});});
      sync();
    });
  }
  function init(){rail();reveal();gallery();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
